import React, { useMemo } from 'react';
import { Badge } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';

export function ProgramTitle() {
    const { eventName } = useParams();
    const { status, events } = useSelector((state) => ({
        status: state.program.program && state.program.program.status,
        events: state.events.events,
    }));
    const badgeText = (status === 'BETA' && 'Предварительная версия') || '';
    const title = useMemo(() => {
        if (!eventName) return '';
        if (events) {
            const event = events.find((ev) => ev.name === eventName);
            if (event) return event.title;
        }
        return '';
    }, [events, eventName]);
    return (
        <>
            {title && <h2 className="text-center mb-1">{title}</h2>}
            {badgeText && (
                <h3 className="text-center mt-0 mb-1">
                    <Badge variant="light" className="font-weight-light text-wrap">
                        {badgeText}
                    </Badge>
                </h3>
            )}
        </>
    );
}
